import React from 'react';
import  ScienceAssociation2025  from 'views/ScienceAssociation2025';
const BlogNewsroomPage = () => {

return <ScienceAssociation2025/>
};

export default BlogNewsroomPage;